"use client";

import { Any, MetricsEvents } from "@cede/types";
import { metricsEventsQueue } from "./metricsEventsQueue";
import { buildQueuedEvent } from "./queuedEvent";
import { analyticsAllowed } from "@/store/consentStore";

const trackedDirectEvents = new Set<string>();

export const clearDirectEventTracking = (eventKey: string) => trackedDirectEvents.delete(eventKey);

/**
 * Tracks a Mixpanel event outside React, where the hook cannot be used or would
 * close a dependency cycle. Events land in the same queue and are sent by the
 * app-level `useMetricsEventsTransport`.
 *
 * @param deduplicationKey - Optional key to prevent duplicate events (e.g., "privy-login-error")
 */
export const trackEventDirect = (
  event: MetricsEvents,
  properties: Record<string, Any> = {},
  deduplicationKey?: string,
): void => {
  // Same rule as the hook path: a refusal reaches the backend-proxied route too.
  if (!analyticsAllowed()) return;

  if (deduplicationKey && trackedDirectEvents.has(deduplicationKey)) {
    return;
  }

  metricsEventsQueue.enqueue(buildQueuedEvent(event, properties));

  if (deduplicationKey) {
    trackedDirectEvents.add(deduplicationKey);
  }
};
